<template>
  <div class="env-display">
    <el-tag :type="currentEnv === 'cn' ? 'success' : 'warning'" size="large">
      {{ currentEnv === 'cn' ? '中国站' : '海外站' }}
    </el-tag>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getCurrentEnv } from '@/config/env'

const currentEnv = ref(getCurrentEnv())

// 监听环境变化
window.addEventListener('storage', (e) => {
  if (e.key === 'currentEnv') {
    currentEnv.value = getCurrentEnv()
  }
})
</script>

<style scoped>
.env-display {
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 100%;
}

:deep(.el-tag) {
  font-size: 14px;
  padding: 0 12px;
  height: 32px;
  line-height: 32px;
}
</style> 